import { ApplicationState } from '@app/store'
import {
  actionCreators as globalActionCreators,
  IGlobalCompsState,
  selectComps,
} from '@app/store/modules/global'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import CompsEditor from '../components/CompsEditor'

export default connect(
  (state: ApplicationState) =>
    createStructuredSelector<ApplicationState, IGlobalCompsState>({
      comps: selectComps(),
    }),
  globalActionCreators,
)(CompsEditor)
